export default {
  methods: {
    mapLayerLiftmaintenanceLifttowersAdd() {
      this.initPollLiftmaintenanceLifttowers();
      this.map.addSource("liftmaintenance-towers-source", {
        type: "geojson",
        data: this.computedLiftmaintenanceLifttowersGeoJson
      });

      // Add towers loop
      for (let i = 1; i < 43; i++) {
        let url =
          "https://d1upyp0je0gcjj.cloudfront.net/liftmaintenance/towers/" +
          i +
          ".png";
        let addImage = "icon-tower-" + i;
        let id = "liftmaintenance-towers-" + i;
        let iconImage = "icon-tower-" + i;
        this.map.loadImage(url, (error, image) => {
          this.map.addImage(addImage, image);
          this.map.addLayer({
            filter: ["==", "twr_num", i],
            id: id,
            type: "symbol",
            source: "liftmaintenance-towers-source",
            layout: {
              "icon-image": iconImage,
              "icon-size": 0.25,
              "icon-allow-overlap": true
            }
          });
          this.map.moveLayer(id, "marker-layer-points");
        });
      }
    },
    mapLayerLiftmaintenanceLifttowersRemove() {
      this.cancelPollLiftmaintenanceLifttowers();
      // remove layers loop
      for (let i = 1; i < 43; i++) {
        let r = "icon-tower-" + i;
        this.map.removeImage(r);
      }

      // remove layers loop
      for (let i = 1; i < 43; i++) {
        let r = "liftmaintenance-towers-" + i;
        this.map.removeLayer(r);
      }
      this.map.removeSource("liftmaintenance-towers-source");
    },
    initPollLiftmaintenanceLifttowers() {
      this.$store.dispatch("actionGetGeoJson", {
        url:
          "https://api2.alchemymapping.com/vail/whistler/liftmaintenance/lifttowers",
        dept: "liftmaintenance",
        layer: "lifttowers",
        token: this.computedAuthToken
      });
      this.pollLiftmaintenancetowersInterval = setInterval(() => {
        this.$store.dispatch("actionGetGeoJson", {
          url:
            "https://api2.alchemymapping.com/vail/whistler/liftmaintenance/lifttowers",
          dept: "liftmaintenance",
          layer: "lifttowers",
          token: this.computedAuthToken
        });
      }, this.computedInterval);
    },
    cancelPollLiftmaintenanceLifttowers() {
      this.pollLiftmaintenanceLifttowersInterval = clearInterval(
        this.pollLiftmaintenanceLifttowersInterval
      );
    }
  },
  computed: {
    computedLiftmaintenanceLifttowersGeoJson() {
      return this.$store.state.mapLayers.liftmaintenance.layers.lifttowers
        .geojson;
    },
    computedLiftmaintenanceLifttowersMapVisibility() {
      return this.$store.state.mapLayers.liftmaintenance.layers.lifttowers
        .visibility.mapView;
    },
    computedAuthToken() {
      return this.$store.state.auth.token;
    },
    computedInterval() {
      return this.$store.state.general.intervalLow;
    }
  },
  watch: {
    "$store.state.mapLayers.liftmaintenance.layers.lifttowers.geojson": {
      handler() {
        if (this.computedLiftmaintenanceLifttowersGeoJson) {
          this.mapLayerLiftmaintenanceLifttowersRemove();
          this.mapLayerLiftmaintenanceLifttowersAdd();
        }
      }
    },
    "$store.state.mapLayers.liftmaintenance.layers.lifttowers.visibility.mapView": function(
      newValue
    ) {
      if (newValue) {
        this.mapLayerLiftmaintenanceLifttowersAdd();
      } else {
        this.mapLayerLiftmaintenanceLifttowersRemove();
      }
    }
  },
  beforeDestroy() {
    this.cancelPollLiftmaintenanceLifttowers();
  }
};
